import type { App } from 'vue'
import { DEFAULT_LOCALE } from 'src/app/config'
import { createI18n } from 'vue-i18n'
import messages from '../i18n'
import { ruRule } from '../i18n/pluralization'

const i18n = createI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  pluralRules: {
    'ru-ru': ruRule,
  },
  legacy: false,
  messages,
})

export function installI18n(app: App) {
  app.use(i18n)
}

export { i18n }
